export class OutcomesLookup {

    static GetOutcome(id: number): string {
        switch (id) {
            case (1): return "VITAL: Autonomic Dysfunction";
            case (2): return "VITAL: Cognitive Dysfunction";
            case (3): return "VITAL: Exercise Intolerance";
            case (4): return "NEURO (tDCS & BrainHQ)";
            case (5): return "AUTONOMIC-1 (IVIG)";
            case (6): return "AUTONOMIC-2 (Ivabradine)";
            case (7): return "SLEEP-1 (Modafinil/Solriamfetol)";
            case (8): return "SLEEP-2 (Melatonin/Light)";
            case (9): return "ENERGIZE-1 (Cardiopulmonary Rehab)";
            case (10): return "ENERGIZE-2 (Structured Pacing)";
            default: return "Unknown";
        }
    }

    static GetOutcomeOrdering(id: number): number {
        switch (id) {
            case (5): return 1; //AUTO-1
            case (6): return 2; //AUTO-2
            case (9): return 3; //ENERGIZE-1
            case (10): return 4; //ENERGIZE-2
            case (4): return 5; // NEURO
            case (7): return 6; //SLEEP-1
            case (8): return 7; //SLEEP-2
            case (1): return 8; // VITAL: AD
            case (2): return 9; // VITAL: CD
            case (3): return 10; // VITAL: EI
            default: return 100; // "Unknown";
        }
    }

    //incremented by 100 to be able to overload logic of status
    static GetReasonMissing(id: number): string {
        switch (id) {
            case (101): return "Missing Day 90 DSQ-PEM";
            case (102): return "Missing Day 90 OHQ";
            case (103): return "Missing Day 90 PROMIS-8a";
            case (104): return "Missing Baseline PROMIS-8a";
            case (105): return "Missing EOI ECOG-2";
            case (106): return "Missing Baseline ECOG-2";
            case (107): return "Missing Baseline OHQ";
            case (108): return "Missing End of Intervention OHQ";
            case (109): return "Missing End of Intervention PROMIS8a-SRI";
            case (110): return "Missing End of Intervention PROMIS8b-SD";
            case (111): return "Missing Baseline ESWT";
            case (112): return "Missing Baseline DSQ-PEM";
            case (113): return "Missing End of Intervention DSQ-PEM";
            case (114): return "Missing End of Intervention ESWT";
            case (115): return "Missing End of Study DSQ-PEM";
            default: return "";
        }
    }

    static GetReasonMissingOrdering(id: number): number {
        switch (id) {
            case (104): return 1; // Missing Baseline PROMIS-8a
            case (112): return 2; // Missing Baseline DSQ-PEM
            case (106): return 3; // Missing Baseline ECOG-2
            case (111): return 4; // Missing Baseline ESWT
            case (107): return 5; // Missing Baseline OHQ
            case (101): return 6; // Missing Day 90 DSQ-PEM
            case (102): return 7; // Missing Day 90 OHQ
            case (103): return 8; // Missing Day 90 PROMIS-8a
            case (113): return 9; // Missing End of Intervention DSQ-PEM
            case (105): return 10; // Missing EOI ECOG-2
            case (108): return 11; //Missing End of Intervention OHQ            
            case (109): return 12; //Missing End of Intervention PROMIS8a-SRI'
            case (110): return 13; //Missing End of Intervention PROMIS8b-SD
            case (114): return 14; // Missing End of Intervention ESWT            
            case (115): return 15; // Missing End of Study DSQ-PEM
            case (100): return 16; // unknown
            default: return 200; // "Unknown";
        }
    }

    static GetReasonMissingOrderingArray(): number[] {
        return [104, 112, 106, 111, 107, 101, 102, 103, 113, 105, 108, 109, 110, 114, 115, 100];
    }

    //overloaded to save extra hashmaps
    static GetOutcomeStatus(id: number): string {
        switch (id) {
            case (1): return "Available";
            case (2): return "Discontinued Prior";
            case (3): return "Primary Outcome Visit Overdue";
            case (4): return "Not Available";
            case (5): return "Not Yet Due";
            case (100): return "Unknown"; //reasons
            case (101): return "Missing Day 90 DSQ-PEM";
            case (102): return "Missing Day 90 OHQ";
            case (103): return "Missing Day 90 PROMIS-8a";
            case (104): return "Missing Baseline PROMIS-8a";
            case (105): return "Missing EOI ECOG-2";
            case (106): return "Missing Baseline ECOG-2";
            case (107): return "Missing Baseline OHQ";
            case (108): return "Missing End of Intervention OHQ";
            case (109): return "Missing End of Intervention PROMIS8a-SRI";
            case (110): return "Missing End of Intervention PROMIS8b-SD";
            case (111): return "Missing Baseline ESWT";
            case (112): return "Missing Baseline DSQ-PEM";
            case (113): return "Missing End of Intervention DSQ-PEM";
            case (114): return "Missing End of Intervention ESWT";
            case (115): return "Missing End of Study DSQ-PEM";
            default: return "Unknown";
        }
    }

    static GetColorIndex(id: number): number {
        switch (id) {
            case (1): return 500; //Available
            case (5): return 501; //Not Yet Due
            case (3): return 502; //Overdue
            case (4): return 503; //Not Done
            case (2): return 504; //Discontinued Prior
            case (104): return 500; //In Window
            case (106): return 501; //
            case (107): return 501; //
            case (101): return 502; //
            case (102): return 503; //
            case (103): return 504; //
            case (105): return 504; //
            case (100): return 505;
            default: return 0;
        }
    }
}